module.exports = __webpack_public_path__ + "img/icon_utill_kr.33ac0741.svg";